import { HttpError, useCustomMutation } from "@refinedev/core";
import { config } from "@src/config";
import { SupportedMeasureType } from "@src/constant/ab-testing/ab-testing-exploration.enum";
import { useABContext } from "@src/contexts/ab-testing/ab-context";
import { FilterFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import {
    IMeasureType,
    IMetricBatchEvaluationResponse,
    IMetricBatchEvaluationResult,
} from "@src/types/ab-testing-exploration";
import { useEffect, useState } from "react";

export const getEvaluateEndpoint = (type?: IMeasureType) => {
    // fallback to average test if not match
    switch (type) {
        case SupportedMeasureType.MEAN:
            return "average-test";
        case SupportedMeasureType.PROPORTION:
            return "proportion-test";
        case SupportedMeasureType.RATIO:
            return "ratio-test";
        default:
            return "average-test";
    }
};

export const useBaseEvaluateMetric = <T>({
    requestPayload,
    apiEndPoint,
    refineOptions,
    isSkip,
    metricType,
}: {
    metricType?: IMeasureType;
    requestPayload: Record<string, any>;
    apiEndPoint: string;
    refineOptions?: {
        dataProviderName?: string;
    };
    isSkip?: boolean;
}) => {
    const [result, setResult] = useState<T[]>();
    const evaluateEndpoint = getEvaluateEndpoint(metricType);
    const { filterForm } = useABContext();
    const productCode = filterForm.getFieldValue(FilterFormFieldsEnum.PRODUCT_CODE);
    const { mutateAsync, isLoading, error } = useCustomMutation<IMetricBatchEvaluationResponse, HttpError>({
        mutationOptions: {
            onSettled(data, error) {
                if (error) {
                    return;
                }
                setResult((data?.data?.data ?? []) as T[]);
            },
        },
    });
    const url = `${config.NESTJS_URL}/api/proxy/v2/abtest/${evaluateEndpoint}${apiEndPoint}`;

    async function fetch() {
        mutateAsync({
            ...refineOptions,
            url,
            method: "post",
            values: requestPayload,
            dataProviderName: "nestjsx",
            config: {
                headers: {
                    "Product-Code": productCode,
                },
            },
        });
    }

    useEffect(() => {
        if (!isSkip) {
            fetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(requestPayload)]);

    return {
        isLoading,
        result,
        httpError: error,
        refetch: fetch,
    };
};
